import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/mobile/drop-records-dialog-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-9280da44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-dialog px-3 d-flex justify-content-between" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "drop-icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "note mt-1 px-3" }
const _hoisted_5 = { class: "filter-date-content d-flex justify-content-between align-items-center text-black px-3" }
const _hoisted_6 = { class: "filter-name" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "filter d-flex flex-column position-absolute bg-white rounded-2"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "empty-packages mt-3 px-3"
}
const _hoisted_12 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_13 = { class: "block d-flex justify-content-between flex-wrap" }
const _hoisted_14 = { class: "type-card text-black e1 mb-1" }
const _hoisted_15 = {
  key: 0,
  class: "points-card text-black e1 mb-1"
}
const _hoisted_16 = {
  key: 1,
  class: "text-black e1 mb-1 points-card"
}
const _hoisted_17 = { class: "block text-end d-flex flex-wrap justify-content-between" }
const _hoisted_18 = { class: "date-card e2" }
const _hoisted_19 = { class: "state-card e2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", {
    class: "dialog-rewards-records",
    ref: "panel",
    onTouchstart: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.startDrag && $setup.startDrag(...args))),
    onTouchmove: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.onDrag && $setup.onDrag(...args))),
    onTouchend: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.endDrag && $setup.endDrag(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, _toDisplayString($setup.local.rewards_dialog_title), 1),
      _createElementVNode("button", {
        class: "border-0 bg-transparent",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleHide()))
      }, _hoisted_3)
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString($setup.local.note_rewards_dialog), 1),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString($setup.local.points_details_3), 1),
      _createElementVNode("div", {
        role: "button",
        ref: "listRef",
        class: "filter-btn position-relative d-flex align-items-center justify-content-end",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleComponent('showFilter')))
      }, [
        _createElementVNode("span", null, _toDisplayString($setup.data.currentFilterVal), 1),
        _hoisted_7,
        _hoisted_8,
        ($setup.state.showFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.valuesFilterDate, (item, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: _normalizeClass(["p-2 py-3", [($setup.state.filterDateVal === item) ? 'clicked btn-item' : 'btn-item']]),
                  key: index,
                  onClick: ($event: any) => ($setup.selectVal(item, index, 'date'))
                }, _toDisplayString($setup.namesFilterDate[index]), 11, _hoisted_10))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    ($setup.data.filteredCards.length == 0 && !$setup.state.showLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.local.points_details_4), 1))
      : _createCommentVNode("", true),
    ($setup.state.showLoading && $setup.data.filteredCards.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_Spinner, { style: {"position":"static !important","margin-top":"16px","color":"#000 !important"} })
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      ref: "scrolledCont",
      onTouchstart: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.startDragS && $setup.startDragS(...args))),
      onTouchmove: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.onDragS && $setup.onDragS(...args))),
      onTouchend: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.endDragS && $setup.endDragS(...args))),
      class: "card-list-content mt-1 pb-3 overflow-auto px-3"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.filteredCards, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "item border-0 mb-3 p-3 bg-white rounded-2"
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(item.type), 1),
            (item.point_type !== 12)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString((+item.points >
                        0) ? `+${item.points}` : item.points), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(item.remark), 1))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString($setup.convertDate(item.created_at)), 1),
            _createElementVNode("div", _hoisted_19, _toDisplayString(item.state), 1)
          ])
        ]))
      }), 128))
    ], 544), [
      [_vShow, $setup.data.filteredCards.length > 0]
    ])
  ], 544))
}